import { useEffect } from "react";
import withRouter from "app/utils/hocs/withRouter";
import Home from "app/pages/Home/Home";
import { useSelector, shallowEqual } from "react-redux";
import { sendTagOnHomePageLoad } from "app/utils/analytics";
import {
	getBrandDisplayName,
	getPartnerCode,
	getPartnerMarketingHomeData,
	getSeoMetaData,
} from "app/reducers/partnerSelector";
import { getCurrentShop } from "app/reducers/shopSelector";

const HomeContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);

	useEffect(() => {
		sendTagOnHomePageLoad();
	}, []);

	return <Home {...props} {...stateProps} />;
};

const mapStateToProps = state => {
	return {
		onGoingProductCount: state.products.length,
		resolution: state.resolution,
		brand: state.brand.code,
		home: getPartnerMarketingHomeData(state),
		shop: getCurrentShop(state),
		partnerCode: getPartnerCode(state),
		productsVisibility: state.productsVisibility,
		brandDisplayName: getBrandDisplayName(state),
		loginTitleFromSanity: getSeoMetaData("login.metaTitle")(state),
		loginDescriptionFromSanity: getSeoMetaData("login.metaDescription")(state),
		signupTitleFromSanity: getSeoMetaData("signup.metaTitle")(state),
		signupDescriptionFromSanity: getSeoMetaData("signup.metaDescription")(state),
	};
};

export default withRouter(HomeContainer);
